import React from 'react';
import { useEffect } from 'react';
import About from '../About';
import Hero from '../Hero';
import Navbar2 from '../Navbar2';
import Service from '../Service';
import Quote from '../Quote';
import ContactForm from '../ContactForm';
import Footer from '../Footer';
import Modal from '../Modal';

function HomePage() {
  useEffect(() => {
    document.title = 'JOBS4US - Home';
  }, []);

  return (
    <div>
      <Navbar2 />
      <Hero />
      <About />
      <Service />
      <Quote />
      <ContactForm />
      <Footer />
      <Modal />
    </div>
  );
}

export default HomePage;
